
<template>
    <div class="prowerSetting">
        <prowerSelect v-bind="$attrs" v-on="$listeners" :linkbreak='linkbreak' />
    </div>
</template>

<script>
import prowerSelect from './prowerSelect.vue'
import {MESSAGE} from '@/util/elementHandle'
    export default {
        data() {
            return {
              tagsList: [],
              childSelect:'',
              inheritAttrs: false,
              linkbreak: true
            }
        },
        props: ['list'],
        components : {
            prowerSelect,
        },
        watch:{
          list (newVal) {
           //  console.log(newVal,'list---')
          }
        },
        methods: {
            treeSettingHandle (data) {
              this.childSelect = 'aaaa'
            }
        },
        mounted () {
        }
    }

</script>


<style lang='scss'>
   
</style>
